import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentRef,
  Type,
  OnDestroy,
  Injector, EventEmitter, Output, ChangeDetectorRef, AfterViewInit
} from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: true
})
export class ModalComponent implements OnDestroy, AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) containerRef!: ViewContainerRef;
  @Output() closeRequested = new EventEmitter<void>();

  private componentRef?: ComponentRef<any>;
  private pendingComponent?: {
    type: Type<any>,
    data?: any,
    callbacks?: Record<string, any>
  };

  constructor(private cdr: ChangeDetectorRef) {
  }

  open<T>(componentType: Type<T>, data?: any, callbacks?: Record<string, any>): void {
    if (!this.containerRef) {
      this.pendingComponent = { type: componentType, data, callbacks };
      return;
    }
    this.containerRef.clear();
    this.componentRef = this.containerRef.createComponent(componentType);

    if (data && this.componentRef.instance) {
      Object.keys(data).forEach(key => {
        (this.componentRef!.instance as any)[key] = data[key];
      });
    }

    if (callbacks && this.componentRef.instance) {
      Object.keys(callbacks).forEach(key => {
        (this.componentRef!.instance as any)[key] = callbacks[key];
      });
    }
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    if (this.pendingComponent) {
      const { type, data, callbacks } = this.pendingComponent;
      this.open(type, data, callbacks);
      //this.pendingComponent = undefined;
    }
  }

  // Called when the user clicks the close button or the backdrop
  requestClose(): void {
    this.closeRequested.emit();
  }

  // If you also want clicking outside the modal to close it
  onOverlayClick(): void {
    this.requestClose();
  }

  close(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = undefined;
    }
  }

  ngOnDestroy(): void {
    this.close();
  }
}
